// One-shot "have we asked this player about Discord yet?" flag.
// Stored client-side because the prompt is purely a UX nudge. We
// don't need cross-device persistence, and a re-prompt on a new
// install is acceptable. Once the player either saves a handle or
// explicitly skips, we set this and the prompt never reappears.

const KEY_PREFIX = 'valkenhall:discord-prompted:';

function storage() {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function wasDiscordPromptShown(playerId) {
  if (!playerId) return true; // No player id → suppress prompt (safe default)
  const ls = storage();
  if (!ls) return false;
  try {
    return ls.getItem(KEY_PREFIX + playerId) === '1';
  } catch {
    return false;
  }
}

export function markDiscordPromptShown(playerId) {
  if (!playerId) return;
  const ls = storage();
  if (!ls) return;
  try {
    ls.setItem(KEY_PREFIX + playerId, '1');
  } catch {
    // Quota / private-mode failures are harmless. Worst case the
    // prompt shows again on next launch, which is no worse than
    // never being able to dismiss it.
  }
}
